import { render, staticRenderFns } from "./ThgRegistrationImageUpload.vue?vue&type=template&id=ca3cb0f4&"
import script from "./ThgRegistrationImageUpload.vue?vue&type=script&lang=ts&"
export * from "./ThgRegistrationImageUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports